// rfce + enter för basic functions etc
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "./Button";
import "./Navbar.css";
import { useAuth } from "./contexts/AuthContext";

// fas fa-times etc is not imported, but that is where the change happens when clicking the logo

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const { logout, currentUser } = useAuth();

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  // is for fixing a refresh issues with the sign up button, not present atm (i think?)
  useEffect(() => {
    showButton();
  }, []);

  // connected to showing a sidebar when on a mobile device
  window.addEventListener("resize", showButton);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            MeMA
          </Link>
          <div className="menu-icon" onClick={handleClick}>
            <i className={click ? "fas fa-times" : "fas fa-bars"} />
          </div>
          {currentUser && (
            <Link to="/upload">
              <Button buttonStyle="btn--outline" href="/upload">
                New post
              </Button>
            </Link>
          )}
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            {/* <li className="nav-item">
              <Link to="/memes" className="nav-links" onClick={closeMobileMenu}>
                Meme market
              </Link>
            </li> */}

            {/* <li className="nav-item">
              <Link to="/about" className="nav-links" onClick={closeMobileMenu}>
                About us
              </Link>
            </li> */}

            {!currentUser && (
              <li className="nav-item">
                <Link
                  to="/login"
                  className="nav-links"
                  onClick={closeMobileMenu}
                >
                  Login
                </Link>
              </li>
            )}
            {currentUser && (
              <li className="nav-item">
                <Link
                  to="/profile"
                  className="nav-links"
                  onClick={closeMobileMenu}
                >
                  Profile
                </Link>
              </li>
            )}
            {currentUser && (
              <li className="nav-item">
                <Link
                  to="/logout"
                  className="nav-links"
                  onClick={async (e) => {
                    e.preventDefault();
                    await logout();
                  }}
                >
                  Logout
                </Link>
              </li>
            )}
          </ul>
          {!currentUser && button && (
            <Link to="/signup">
              <Button buttonStyle="btn--outline" href="/signup">
                SIGN UP
              </Button>
            </Link>
          )}
        </div>
      </nav>
    </>
  );
}

export default Navbar;
